import { memo, useEffect, useRef, useState } from 'react';
import { Mark } from '../brand/brand';
import { useSettings } from '../state/settings';
import { useWm } from './wm';
import { useReducedMotion } from './motion';

function WallpaperImpl() {
  const reduce=useReducedMotion(),ambient=useSettings(s=>s.ambientMotion);
  const open=useWm(s=>Object.values(s.wins).some(w=>w&&!w.minimized&&w.phase==='open'));
  const [hello,setHello]=useState(false),[stage,setStage]=useState({width:1586,height:992,left:0,top:0});
  const container=useRef<HTMLDivElement>(null),timer=useRef<ReturnType<typeof setTimeout>|null>(null);
  useEffect(()=>{
    const el=container.current;if(!el)return;
    const resize=()=>{
      const width=el.clientWidth,height=el.clientHeight;if(!width||!height)return;
      const mobile=width<=640,sceneHeight=mobile?Math.min(360,Math.max(160,height-450)):height;
      const scale=Math.max(width/1586,sceneHeight/992),w=1586*scale,h=992*scale;
      setStage({width:w,height:h,left:-(w-width)*(width<=930?.83:.5),top:(mobile?height-sceneHeight:0)-(h-sceneHeight)/2});
    };
    const observer=new ResizeObserver(resize);observer.observe(el);resize();
    return()=>{observer.disconnect();if(timer.current)clearTimeout(timer.current);};
  },[]);
  return <div ref={container} className={'wall nimu-wall'+(!ambient||reduce||open?' nimu-wall-paused':'')}>
    <div className="nimu-scene" style={stage}>
      <img className="nimu-wallpaper-image" src="/brand/nimu-wallpaper.webp" width={1586} height={992} alt="" decoding="async" draggable={false}/>
      <button className={'nimu-wall-ghost'+(hello?' waving':'')} aria-label="Say hello to NimoOS" onClick={()=>{if(timer.current)clearTimeout(timer.current);setHello(true);timer.current=setTimeout(()=>setHello(false),2200);}}><Mark size={480}/></button>
      {hello&&<span className="nimu-ghost-hello" role="status">boo. good to see you.</span>}
    </div>
    <div className="nimu-wall-caption" aria-hidden="true"><span>meet your little</span><strong>happy place.</strong><small>NIMOOS PERSONAL COMPUTER</small></div>
  </div>;
}
export const Wallpaper=memo(WallpaperImpl);
